import React, { Component } from 'react';
import styled from 'styled-components';

const TelegramPostContainer = styled.div`
  max-width: 500px;
`;

export class TelegramPost extends Component {
  constructor(props) {
    super(props);
    this.markerRef = React.createRef();
  }

  componentDidMount() {
    const el = this.markerRef.current;
    const { postId } = this.props
    if (el && postId) {
      const addScript = document.createElement('script');
      addScript.setAttribute('src', 'https://telegram.org/js/telegram-widget.js?7');
      addScript.setAttribute('async', 'async');
      addScript.setAttribute('data-telegram-post', `okolodev${postId}`);
      addScript.setAttribute('data-width', '100%');
      addScript.setAttribute('data-userpic', 'false');
      el.appendChild(addScript);
    }
  }

  render() {
    const { postId } = this.props
    return postId && <TelegramPostContainer
      ref={this.markerRef}
    />
  }
}
